var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "presentation-slide-information container w-1920 h-1080 nopadding",
    },
    [
      _c("div", { staticClass: "row", staticStyle: { height: "100%" } }, [
        _c("div", { staticClass: "col-md-4 px-4" }, [
          _c("div", { staticClass: "slide-info-brand-column" }, [
            _c("div", { staticClass: "presentation-title" }, [
              _vm._v("2022 Election results"),
            ]),
            _c("div", [
              this.ward
                ? _c("div", { staticClass: "slide-info-ward" }, [
                    _vm._v(_vm._s(this.ward)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "slide-info-position my-4" }, [
                _vm._v(" " + _vm._s(this.position) + " "),
                _c("br"),
                Math.ceil(this.candidates.Candidates.length / 10) > 1
                  ? _c("span", { staticClass: "slide-info-pagination" }, [
                      _vm._v(
                        _vm._s(this.page) +
                          " of " +
                          _vm._s(
                            Math.ceil(this.candidates.Candidates.length / 10)
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "logos container" }, [
              _c("div", { staticClass: "col-6 pr-5" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "100%",
                      viewBox: "0 0 115 55.774",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Group_8592",
                          "data-name": "Group 8592",
                          transform: "translate(-162.8 -192.9)",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "Path_5863",
                            "data-name": "Path 5863",
                            d: "M245.1,192.9a1.977,1.977,0,0,0-.986.271L220.3,209.05l-23.843-15.879a1.888,1.888,0,0,0-.962-.271,1.847,1.847,0,0,0-1.874,1.825v31.61a1.847,1.847,0,0,0,1.874,1.825,1.752,1.752,0,0,0,.912-.247l14.893-9.937,7.372,9.394a2.073,2.073,0,0,0,3.255,0l7.372-9.394,14.967,9.986a1.991,1.991,0,0,0,.838.2,1.847,1.847,0,0,0,1.874-1.825v-31.61A1.847,1.847,0,0,0,245.1,192.9Zm-.567,5.572v26.753l-13.759-9.172Zm-34.717,17.58-13.759,9.172V198.472Zm17.432.567-6.953,8.9-6.953-8.9,6.953-4.636Zm-9.148-6.09-6.263,4.167-13.685-17.482Zm24.336-13.315L228.757,214.7l-6.263-4.167Zm-7.718,39.131a9.476,9.476,0,0,0-4.216.986.271.271,0,0,0-.148.345l.493,1.381a.283.283,0,0,0,.395.173,7.506,7.506,0,0,1,3.3-.814c1.405,0,3.082.493,3.082,2.86a12.581,12.581,0,0,0-3.181-.395c-3.156,0-5.129,1.529-5.129,3.97,0,2.515,2.268,3.822,4.512,3.822a5.216,5.216,0,0,0,3.8-1.479v.962a.318.318,0,0,0,.3.3h1.627a.3.3,0,0,0,.271-.3V241.2c0-3.131-1.8-4.857-5.1-4.857Zm-59.892,12.082h-1.677a.28.28,0,0,1-.3-.271V240.34l-3.551,5.03a.342.342,0,0,1-.247.123h-.247a.3.3,0,0,1-.247-.123l-3.551-5.005v7.792a.3.3,0,0,1-.3.271h-1.652a.274.274,0,0,1-.271-.271V236.863a.28.28,0,0,1,.271-.3h1.874a.342.342,0,0,1,.247.123l3.773,5.425,3.748-5.425a.342.342,0,0,1,.247-.123h1.874a.28.28,0,0,1,.271.3v11.293a.274.274,0,0,1-.271.271Zm85.609.247a6.166,6.166,0,1,1-.1-12.329,6.614,6.614,0,0,1,4.734,1.775c.173.148.148.3.049.395l-1.085,1.282a.289.289,0,0,1-.419.049,4.386,4.386,0,0,0-3.329-1.331,3.682,3.682,0,0,0-3.871,3.846,3.847,3.847,0,0,0,4.044,4.192,4.92,4.92,0,0,0,2.836-.912v-1.973H260.1a.28.28,0,0,1-.271-.3v-1.553a.274.274,0,0,1,.271-.271h5.129a.28.28,0,0,1,.3.271v4.66c0,.148-.074.222-.2.345a7.454,7.454,0,0,1-4.882,1.849Zm-13.931,0c-2.712,0-4.562-1.6-4.562-4.808v-7.027a.3.3,0,0,1,.3-.271h1.677a.28.28,0,0,1,.3.271v6.83c0,1.627.567,2.91,2.638,2.91s3.107-1.282,3.107-3.255v-6.485a.3.3,0,0,1,.3-.271h1.652a.28.28,0,0,1,.3.271v11.318a.3.3,0,0,1-.3.3h-1.652a.318.318,0,0,1-.3-.3V247.1a4.039,4.039,0,0,1-3.452,1.578Zm-8.876-4.685c0,1.6-1.5,2.786-3.477,2.786-1.233,0-2.54-.616-2.54-2,0-1.307,1.085-2.071,3.008-2.071a11.5,11.5,0,0,1,3.008.419ZM213,248.674a8.329,8.329,0,0,1-4.956-1.726.278.278,0,0,1-.049-.395l.863-1.208a.275.275,0,0,1,.419-.074,6.442,6.442,0,0,0,3.822,1.381c1.233,0,2.1-.592,2.1-1.5,0-.937-1.159-1.356-2.663-1.775-1.7-.468-4.044-1.11-4.044-3.477,0-2.121,1.726-3.551,4.216-3.551a8.234,8.234,0,0,1,4.315,1.282.3.3,0,0,1,.074.395l-.74,1.208c-.123.2-.247.247-.419.148a6.115,6.115,0,0,0-3.279-1.036c-1.159,0-1.923.542-1.923,1.381,0,.863,1.307,1.258,2.762,1.677,1.553.468,3.9,1.184,3.9,3.551,0,2.244-1.775,3.723-4.389,3.723Zm10.405,0a8.385,8.385,0,0,1-4.389-1.331.264.264,0,0,1-.074-.395l.888-1.233a.272.272,0,0,1,.37-.074,6.345,6.345,0,0,0,3.279,1.011c1.257,0,2.1-.592,2.1-1.5,0-.937-1.159-1.356-2.663-1.775-1.7-.468-4.019-1.11-4.019-3.477,0-2.121,1.726-3.551,4.216-3.551a8.234,8.234,0,0,1,4.315,1.282.3.3,0,0,1,.074.395l-.789,1.258a.257.257,0,0,1-.395.1,6.216,6.216,0,0,0-3.255-1.036c-1.159,0-1.948.542-1.948,1.356,0,.888,1.331,1.282,2.737,1.7,1.578.468,3.945,1.184,3.945,3.551,0,2.244-1.775,3.723-4.389,3.723Zm-17.556-.222h-1.677a.3.3,0,0,1-.3-.3V236.839a.28.28,0,0,1,.3-.271h1.677a.3.3,0,0,1,.3.271v11.318a.318.318,0,0,1-.3.3Zm-18.838.222a8.329,8.329,0,0,1-4.956-1.726.278.278,0,0,1-.049-.395l.863-1.208a.275.275,0,0,1,.419-.074,6.442,6.442,0,0,0,3.822,1.381c1.233,0,2.1-.592,2.1-1.5,0-.937-1.159-1.356-2.663-1.775-1.7-.468-4.044-1.11-4.044-3.477,0-2.121,1.726-3.551,4.216-3.551a8.234,8.234,0,0,1,4.315,1.282.3.3,0,0,1,.074.395l-.74,1.208c-.123.2-.247.247-.419.148a6.114,6.114,0,0,0-3.279-1.036c-1.159,0-1.923.542-1.923,1.381,0,.863,1.307,1.258,2.762,1.677,1.553.468,3.9,1.184,3.9,3.551,0,2.244-1.775,3.723-4.389,3.723Zm10.405,0a8.385,8.385,0,0,1-4.389-1.331.264.264,0,0,1-.074-.395l.888-1.233a.272.272,0,0,1,.37-.074,6.345,6.345,0,0,0,3.279,1.011c1.258,0,2.1-.592,2.1-1.5,0-.937-1.159-1.356-2.663-1.775-1.7-.468-4.019-1.11-4.019-3.477,0-2.121,1.726-3.551,4.216-3.551a8.234,8.234,0,0,1,4.315,1.282.3.3,0,0,1,.074.395l-.789,1.258a.257.257,0,0,1-.395.1,6.216,6.216,0,0,0-3.255-1.036c-1.159,0-1.948.542-1.948,1.356,0,.888,1.331,1.282,2.737,1.7,1.578.468,3.945,1.184,3.945,3.551,0,2.244-1.775,3.723-4.389,3.723Zm-17.556-.222h-1.677a.3.3,0,0,1-.3-.3V236.839a.28.28,0,0,1,.3-.271h1.677a.3.3,0,0,1,.3.271v11.318a.318.318,0,0,1-.3.3ZM272.7,236.346a9.476,9.476,0,0,0-4.216.986.271.271,0,0,0-.148.345l.493,1.381a.283.283,0,0,0,.395.173,7.506,7.506,0,0,1,3.3-.814c1.405,0,3.082.493,3.082,2.86a12.581,12.581,0,0,0-3.181-.395c-3.156,0-5.129,1.529-5.129,3.97,0,2.515,2.268,3.822,4.512,3.822a5.216,5.216,0,0,0,3.8-1.479v.962a.318.318,0,0,0,.3.3h1.627a.3.3,0,0,0,.271-.3V241.2c0-3.131-1.8-4.857-5.1-4.857Zm2.91,7.644c0,1.6-1.5,2.786-3.477,2.786-1.233,0-2.54-.616-2.54-2,0-1.307,1.085-2.071,3.008-2.071a11.5,11.5,0,0,1,3.008.419Z",
                            transform: "translate(0)",
                            fill: "#1a1818",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "col-6 pl-5" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      id: "Group_7804",
                      "data-name": "Group 7804",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "100%",
                      viewBox: "0 0 120 107.529",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Group_7802",
                          "data-name": "Group 7802",
                          transform: "translate(34.929 0)",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "Path_5525",
                            "data-name": "Path 5525",
                            d: "M238.155,121.3c-2.415,0-3.988,1.726-4.448,4.372h8.781C242.143,123.06,240.609,121.3,238.155,121.3Z",
                            transform: "translate(-168.473 -82.662)",
                            fill: "#0077c8",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            id: "Path_5526",
                            "data-name": "Path 5526",
                            d: "M182.709,77.111a42.535,42.535,0,1,0-20.184,42.538l11.794,4.688-1.948-12.868A42.464,42.464,0,0,0,182.709,77.111Zm-72.08,18.908-8.091-20.707h6.174l4.6,13.766,4.64-13.766h6.058l-8.091,20.707Zm33.781-10.392a10.788,10.788,0,0,1-11.159,10.7c-6.366,0-11.082-4.717-11.082-10.622v-.077a10.788,10.788,0,0,1,11.159-10.7c6.366,0,11.082,4.717,11.082,10.622ZM157.37,80.3h-4.831v8.782c0,1.342.575,1.994,1.879,1.994a5.933,5.933,0,0,0,2.876-.729v4.678a8.6,8.6,0,0,1-4.6,1.188c-3.566,0-5.982-1.419-5.982-6.174V80.3h-2.454V75.312h2.454V70.058h5.829v5.254h4.831ZM157.6,85.7v-.077c0-5.867,4.18-10.7,10.162-10.7,6.864,0,10.009,5.33,10.009,11.16,0,.46-.039,1-.076,1.533h-14.3a4.768,4.768,0,0,0,5.024,4.027,6.736,6.736,0,0,0,4.985-2.11l3.337,2.953a10.282,10.282,0,0,1-8.4,3.835C162.161,96.326,157.6,91.992,157.6,85.7Z",
                            transform: "translate(-98.077 -40.973)",
                            fill: "#0077c8",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            id: "Path_5527",
                            "data-name": "Path 5527",
                            d: "M165.457,122.014a5.266,5.266,0,0,0-5.33,5.6v.076a5.461,5.461,0,0,0,5.407,5.676,5.266,5.266,0,0,0,5.33-5.6v-.077A5.461,5.461,0,0,0,165.457,122.014Z",
                            transform: "translate(-130.283 -83.035)",
                            fill: "#0077c8",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Group_7803",
                          "data-name": "Group 7803",
                          transform: "translate(0 52.067)",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "Path_5528",
                            "data-name": "Path 5528",
                            d: "M61.036,205.566a2.692,2.692,0,0,0-2.725,2.862v.039a2.792,2.792,0,0,0,2.764,2.9,2.692,2.692,0,0,0,2.725-2.862v-.039A2.792,2.792,0,0,0,61.036,205.566Z",
                            transform: "translate(-41.794 -179.117)",
                            fill: "#00629b",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            id: "Path_5529",
                            "data-name": "Path 5529",
                            d: "M98.209,205.2a2.341,2.341,0,0,0-2.274,2.235h4.489A2.253,2.253,0,0,0,98.209,205.2Z",
                            transform: "translate(-61.322 -178.927)",
                            fill: "#00629b",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            id: "Path_5530",
                            "data-name": "Path 5530",
                            d: "M74.808,176.867l-5.343,5.882h5.449v2.411H65.779v-2.1l5.43-6H65.955v-2.411h6.082a45.828,45.828,0,0,1-14.383-23.435c-.224-.048-.444-.1-.67-.145a27.679,27.679,0,0,0-26.7,44.759l-1.618,8.36,7.836-2.748a27.851,27.851,0,0,0,42.647-17.926,28.045,28.045,0,0,0,.421-3.548A46.5,46.5,0,0,1,74.808,176.867ZM34.35,185.239H31.645l-4.136-10.586h3.156l2.352,7.038,2.372-7.038h3.1Zm14.566-5.312a5.69,5.69,0,0,1-11.369.039v-.039a5.69,5.69,0,0,1,11.369-.039Zm6.627-2.725h-2.47v4.489c0,.686.294,1.019.96,1.019a3.027,3.027,0,0,0,1.47-.373v2.392a4.4,4.4,0,0,1-2.352.608c-1.823,0-3.058-.726-3.058-3.157V177.2H48.84v-2.549h1.254v-2.685h2.98v2.685h2.47Zm5.607,8.194a5.255,5.255,0,0,1-5.488-5.43v-.039a5.231,5.231,0,0,1,5.195-5.469c3.509,0,5.116,2.725,5.116,5.7,0,.235-.019.509-.039.784H58.623A2.436,2.436,0,0,0,61.19,183a3.443,3.443,0,0,0,2.548-1.078l1.706,1.509A5.255,5.255,0,0,1,61.151,185.4Z",
                            transform: "translate(-23.97 -150.575)",
                            fill: "#00629b",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            this.candidates
              ? _c("a-table", {
                  attrs: {
                    item: this.candidates,
                    index: this.position,
                    page: this.page,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }